import React, { useEffect, useMemo, useState } from "react";
import { Widget } from "./Widget";
import { GRAPH_TYPES } from "../../../constants/app-constant";
import {
  DATA_TYPES_OPTIONS,
  DATA_TYPES,
} from "../../../constants/static-filter";
import HorizontalTabs from "../../Shared/HorizontalTabs";
const { PIE, DOUGHNUT, BAR_VERTICAL } = GRAPH_TYPES;
export default function EmbededFeedWidget({
  widget,
  setShowWidgetConfig,
  setEditWidgetData,
  setEmbededFeedsParams,
  setEmbededRouteParams,
  inlineGraphTypeOptions,
  onWidgetDelete,
  setWidgetCreationStatus,
  fetchWidgets,
  selectedDataType,
  preSelectedWCType,
  countryWiseFeeds,
  isAnalysisReport,
  contributedWidgetFilter,
  twitterFeeds,
  keyMetrics,
  twitterMetricsData,
  twitterBreakDownLine,
  twitterBreakDownPie,
  startRange,
  endRange,
  tonality,
  topicId,
  widgetApiInProgress,
  tabData,
}) {
  const [selectedGraphType, setSelectedGraphType] = useState(widget.graph_type);
  const [selectedEmbededDataType, setSelectedEmbededDataType] = useState(
    DATA_TYPES.NUMBER
  );

  useEffect(() => {
    setSelectedGraphType(widget.graph_type);
  }, [widget]);

  const defaultWidget = { ...widget, graph_type: selectedGraphType };
  return (
    <>
      <div className={`embededWidget`}>
        <Widget
          key={`embeded-widget`}
          widget={defaultWidget}
          onDelete={onWidgetDelete}
          setShowWidgetConfig={setShowWidgetConfig}
          setEditWidgetData={setEditWidgetData}
          setEmbededFeedsParams={setEmbededFeedsParams}
          setEmbededRouteParams={setEmbededRouteParams}
          isEmbededWidget
          setWidgetCreationStatus={setWidgetCreationStatus}
          fetchWidgets={fetchWidgets}
          inlineGraphTypeOptions={inlineGraphTypeOptions}
          selectedDataType={selectedEmbededDataType}
          preSelectedWCType={preSelectedWCType}
          countryWiseFeeds={countryWiseFeeds}
          isAnalysisReport={isAnalysisReport}
          contributedWidgetFilter={contributedWidgetFilter}
          twitterFeeds={twitterFeeds}
          topicId={topicId}
          startRange={startRange}
          endRange={endRange}
          tonality={tonality}
          twitterBreakDownPie={twitterBreakDownPie}
          twitterBreakDownLine={twitterBreakDownLine}
          keyMetrics={keyMetrics}
          twitterMetricsData={twitterMetricsData}
          tabData={tabData}
          widgetApiInProgress={widgetApiInProgress}
          selectedEmbededGraphType={selectedGraphType}
        />
      </div>
      <div className="fcTabsWrap">
        {(selectedGraphType == PIE || selectedGraphType == DOUGHNUT || selectedGraphType == BAR_VERTICAL) && (
          <HorizontalTabs
            data={DATA_TYPES_OPTIONS}
            selectedTab={selectedEmbededDataType}
            setSelectedTab={setSelectedEmbededDataType}
            activeClass="active"
          />
        )}
        <HorizontalTabs
          data={inlineGraphTypeOptions}
          selectedTab={selectedGraphType}
          setSelectedTab={setSelectedGraphType}
          activeClass="active"
        />
      </div>
    </>
  );
}

EmbededFeedWidget.defaultProps = {
  widget: {},
  onDelete: () => { },
  setEditWidgetData: () => { },
  onWidgetDelete: () => { },
};
